/**
 * Created by summer on 2020/9/18.
 */

// 我的
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    // mode:'history',
    routes: [ {
        path: '/present/index',
        name: 'presentIndex',
        component: () =>
            import('@/components/present/index'),
        meta: {
            // 页面标题title
            title: '首页'
        }
    },{
        path: '/present/my',
        name: 'presentMy',
        component: () =>
            import('@/components/present/my'),
        meta: {
            // 页面标题title
            title: '家长端'
        }
    },{
        path: '/present/subscribe',
        name: 'presentSubscribe',
        component: () =>
            import('@/components/present/subscribe'),
        meta: {
            // 页面标题title
            title: '课程预约'
        }
    },{
        path: '/present/comment',
        name: 'presentComment',
        component: () =>
            import('@/components/present/comment'),
        meta: {
            // 页面标题title
            title: '教练点评'
        }
    },{
        path: '/present/child-nbind',
        name: 'presentChildNbind',
        component: () =>
            import('@/components/present/child-nbind'),
        meta: {
            // 页面标题title
            title: '未绑定孩子'
        }
    },{
        path: '/present/child-bind',
        name: 'presentChildbind',
        component: () =>
            import('@/components/present/child-bind'),
        meta: {
            // 页面标题title
            title: '绑定孩子'
        }
    },{
        path: '/present/edit',
        name: 'presentEdit',
        component: () =>
            import('@/components/present/edit'),
        meta: {
            // 页面标题title
            title: '修改资料'
        }
    },{
        path: '/present/more-class',
        name: 'presentMoreClass',
        component: () =>
            import('@/components/present/more-class'),
        meta: {
            // 页面标题title
            title: '更多记录'
        }
    },{
        path: '/present/members',
        name: 'presentMembers',
        component: () =>
            import('@/components/present/members'),
        meta: {
            // 页面标题title
            title: '课程人数'
        }
    },{
        path: '/present/detail',
        name: 'presentDetail',
        component: () =>
            import('@/components/present/detail'),
        meta: {
            // 页面标题title
            title: '课程详情'
        }
    },{
        path: '/present/invite',
        name: 'presentInvite',
        component: () =>
            import('@/components/present/invite'),
        meta: {
            // 页面标题title
            title: '邀请人'
        }
    },{
        path: '/present/renew',
        name: 'presentRenew',
        component: () =>
            import('@/components/present/renew'),
        meta: {
            // 页面标题title
            title: '连续约课'
        }
    },{
        path: '/coach/statistics',
        name: 'coachStatistics',
        component: () =>
            import('@/components/coach/statistics'),
        meta: {
            // 页面标题title
            title: '课时统计'
        }
    },{
        path: '/coach/have-class',
        name: 'coachHaveClass',
        component: () =>
            import('@/components/coach/have-class'),
        meta: {
            // 页面标题title
            title: '课程'
        }
    },{
        path: '/coach/more-class',
        name: 'coachMoreClass',
        component: () =>
            import('@/components/coach/more-class'),
        meta: {
            // 页面标题title
            title: '更多课程'
        }
    },{
        path: '/coach/my',
        name: 'coachMy',
        component: () =>
            import('@/components/coach/my'),
        meta: {
            // 页面标题title
            title: '教练端'
        }
    },{
        path: '/coach/members',
        name: 'coachMembers',
        component: () =>
            import('@/components/coach/members'),
        meta: {
            // 页面标题title
            title: '课程人数'
        }
    },{
        path: '/coach/coach-bind',
        name: 'coachCoachBind',
        component: () =>
            import('@/components/coach/coach-bind'),
        meta: {
            // 页面标题title
            title: '绑定教练'
        }
    },{
        path: '/coach/detail',
        name: 'coachDetail',
        component: () =>
            import('@/components/coach/detail'),
        meta: {
            // 页面标题title
            title: '课程详情'
        }
    },{
        path: '/coach/comment',
        name: 'coachComment',
        component: () =>
            import('@/components/coach/comment'),
        meta: {
            // 页面标题title
            title: '教练点评'
        }
    },{
        path: '/coach/own-comment',
        name: 'coachOwnComment',
        component: () =>
            import('@/components/coach/own-comment'),
        meta: {
            // 页面标题title
            title: '内部评论'
        }
    },{
        path: '/class/detail',
        name: 'coachDetail',
        component: () =>
            import('@/components/class/detail'),
        meta: {
            // 页面标题title
            title: '课程详情'
        }
    },{
        path: '/class/members',
        name: 'classMembers',
        component: () =>
            import('@/components/class/members'),
        meta: {
            // 页面标题title
            title: '课程人数'
        }
    },{
        path: '/class/sign',
        name: 'classSign',
        component: () =>
            import('@/components/class/sign'),
        meta: {
            // 页面标题title
            title: '签到情况'
        }
    },{
        path: '/class/period',
        name: 'classPeriod',
        component: () =>
            import('@/components/class/period'),
        meta: {
            // 页面标题title
            title: '课时明细'
        }
    },{
        path: '/login/pwd',
        name: 'loginPwd',
        component: () =>
            import('@/components/login/pwd'),
        meta: {
            // 页面标题title
            title: '密码登录'
        }
    },{
        path: '/login/code',
        name: 'loginCode',
        component: () =>
            import('@/components/login/code'),
        meta: {
            // 页面标题title
            title: '验证码登录'
        }
    },{
        path: '/class/adviser',
        name: 'classAdviser',
        component: () =>
            import('@/components/class/adviser'),
        meta: {
            // 页面标题title
            title: '课程顾问'
        }
    },{
        path: '/adviser/my',
        name: 'adviserMy',
        component: () =>
            import('@/components/adviser/my'),
        meta: {
            // 页面标题title
            title: '顾问端'
        }
    },{
        path: '/adviser/child-info',
        name: 'adviserChildInfo',
        component: () =>
            import('@/components/adviser/child-info'),
        meta: {
            // 页面标题title
            title: '顾问端'
        }
    },{
        path: '/adviser/period',
        name: 'adviserPeriod',
        component: () =>
            import('@/components/adviser/period'),
        meta: {
            // 页面标题title
            title: '课时明细'
        }
    },{
        path: '/adviser/more-class',
        name: 'adviserMoreClass',
        component: () =>
            import('@/components/adviser/more-class'),
        meta: {
            // 页面标题title
            title: '更多记录'
        }
    },{
        path: '/adviser/adviser-bind',
        name: 'adviserAdviserbind',
        component: () =>
            import('@/components/adviser/adviser-bind'),
        meta: {
            // 页面标题title
            title: '绑定顾问'
        }
    },{
        path: '/adviser/comment',
        name: 'adviserComment',
        component: () =>
            import('@/components/adviser/comment'),
        meta: {
            // 页面标题title
            title: '教练点评'
        }
    },{
        path: '/adviser/members',
        name: 'adviserMembers',
        component: () =>
            import('@/components/adviser/members'),
        meta: {
            // 页面标题title
            title: '课程人数'
        }
    },{
        path: '/adviser/detail',
        name: 'adviserDetail',
        component: () =>
            import('@/components/adviser/detail'),
        meta: {
            // 页面标题title
            title: '课程详情'
        }
    },{
        path: '/adviser/own-comment',
        name: 'adviserOwnComment',
        component: () =>
            import('@/components/adviser/own-comment'),
        meta: {
            // 页面标题title
            title: '内部评论'
        }
    }]
    
})




//////////////////
// WEBPACK FOOTER
// ./common/router/index.js
// module id = null
// module chunks = 